/**
 * Vendor-agnostic journal import result. Used by both D365 BC and Abacus
 * import flows so the FE summary modal, card status and reducer slice can be
 * shared. Vendors with diverging fields keep them under separate keys on the
 * BE side; the FE result shape stays the same.
 */

export interface IJournalImportAccount {
    accountNo: string;
    accountName: string;
    category:
        | 'Assets'
        | 'Liabilities'
        | 'Equity'
        | 'Income'
        | 'CostOfGoodsSold'
        | 'Expense'
        | '';
    /** Sign corrected on the BE side for display; render as is. */
    saldo: number;
}

export interface IJournalImportValidation {
    assets: number;
    liabilities: number;
    /** false if assets and liabilities differ by more than 0.05 LCY. */
    balanced: boolean;
}

export interface IJournalImportResult {
    accounts: IJournalImportAccount[];
    /** Only present when the request supplied both `previousFiscalYear*` fields. */
    previousYearAccounts?: IJournalImportAccount[];
    period: { from: string; to: string };
    /** Count of source General Ledger entries pulled from the vendor. */
    entryCount: number;
    accountCount: number;
    validation: {
        currentYear: IJournalImportValidation;
        /** Only present when previous year was requested. */
        previousYear?: IJournalImportValidation;
    };
}
